/** Auto-save settings from Vite env (defaults: enabled, once per 60s while dirty). */

const parseBool = (value: string | undefined, fallback: boolean): boolean => {
  if (value === undefined || value === '') return fallback;
  return value === 'true' || value === '1';
};

const parseMs = (value: string | undefined, fallback: number): number => {
  if (value === undefined || value === '') return fallback;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

export const AUTO_SAVE_ENABLED = parseBool(import.meta.env.VITE_AUTO_SAVE_ENABLED, true);
export const AUTO_SAVE_IDLE_MS = parseMs(import.meta.env.VITE_AUTO_SAVE_IDLE_MS, 60_000);
